export const navLinks = [
  { label: 'Home', href: '#home' },
  { label: 'About Us', href: '#about' },
  { label: 'Fleet & Services', href: '#services' },
  { label: 'Coverage', href: '#coverage' },
  { label: 'Contact', href: '#contact' },
]

export const footerLinks = [
  { label: 'Home', href: '#home' },
  { label: 'About', href: '#about' },
  { label: 'Services', href: '#services' },
  { label: 'Fleet', href: '#fleet' },
  { label: 'Coverage', href: '#coverage' },
  { label: 'Contact', href: '#contact' },
]

export interface Stat {
  value?: number
  text?: string
  suffix?: string
  headline: string
  label: string
}

export const stats: Stat[] = [
  { value: 48, headline: 'States', label: 'Nationwide coverage' },
  { text: '24/7', headline: 'Dispatch', label: 'Dispatch & communication' },
  { value: 100, suffix: '%', headline: 'Food-Grade', label: 'Food-grade equipment' },
  { value: 2018, headline: 'Established', label: 'Operating since 2018' },
]

export const complianceBadges = [
  {
    title: 'Air-Ride & Food-Grade',
    detail: 'Air-ride suspension with washed-out, sealed food-grade trailer interiors.',
  },
  {
    title: 'Fully Insured & Compliant',
    detail: 'Comprehensive coverage and strict adherence to federal transportation requirements.',
  },
  {
    title: '48-State Coverage',
    detail: 'Long-haul OTR capability across every major freight corridor in the lower 48.',
  },
]

export const services = [
  {
    title: 'Fresh Produce, Plants & Flowers',
    description:
      'Temperature-sensitive transportation designed to protect freshness from pickup through delivery.',
    temp: '34°F – 55°F',
  },
  {
    title: 'Raw & Processed Meats',
    description: 'Food-grade refrigerated transportation with careful temperature management.',
    temp: '28°F – 34°F',
  },
  {
    title: 'Seafood',
    description: 'Port-to-warehouse and distribution logistics for refrigerated and frozen seafood.',
    temp: '30°F – 34°F',
  },
  {
    title: 'Refrigerated & Ultra-Frozen Goods',
    description: 'Reliable temperature-controlled transportation for demanding cold-chain shipments.',
    temp: '-20°F – 10°F',
  },
  {
    title: 'Dry Freight & Finished Products',
    description: 'Flexible capacity for selected dry freight and finished goods.',
    temp: 'Ambient',
  },
]

export const fleetFeatures = [
  { title: 'Air-Ride Suspension', detail: 'Smooth transit for fragile and palletized cold-chain freight.' },
  { title: 'Food-Grade Trailers', detail: 'Utility 3000R reefers washed out and sealed before every load.' },
  { title: 'Temperature-Controlled', detail: 'Continuous set-point control from fresh to ultra-frozen.' },
  { title: 'Modern Highway Equipment', detail: '2024 Freightliner Cascadia tractors maintained on schedule.' },
  { title: 'Winter-Ready Operations', detail: 'Equipped and staffed for severe winter freight corridors.' },
]

export const driverPoints = [
  { title: 'Safety First', detail: 'Disciplined pre-trip inspections, hours compliance, and defensive driving.' },
  { title: 'Clear Communication', detail: 'Check calls and status updates from pickup through delivery.' },
  { title: 'Delivery-Focused', detail: 'Appointment discipline and accountability on every mile.' },
]

export const whyCards = [
  { title: 'Reliability', detail: 'We understand the cost of delays and missed appointments.' },
  { title: 'Temperature Control', detail: 'Food-grade refrigerated equipment built for sensitive freight.' },
  { title: 'Communication', detail: 'Clear updates from pickup through delivery.' },
  { title: 'Nationwide Capability', detail: 'Long-haul transportation across major US freight corridors.' },
]

export const fleetSpecs = [
  { label: 'Tractors', value: '2024 Freightliner Cascadia' },
  { label: 'Trailers', value: '2026 & 2020 Utility 3000R' },
  { label: 'Suspension', value: 'Air-ride, food-grade interior' },
  { label: 'Operation', value: 'OTR long-haul, 48 states' },
]

export const cargoTypes = [
  'Fresh Produce, Plants & Flowers',
  'Raw & Processed Meats',
  'Seafood',
  'Refrigerated & Ultra-Frozen',
  'Dry Freight & Finished Products',
  'Other',
]

export const coverageHubs = [
  { name: 'Davenport, FL', x: 84, y: 79, hq: true },
  { name: 'Los Angeles, CA', x: 9, y: 55 },
  { name: 'Seattle, WA', x: 10, y: 10 },
  { name: 'Chicago, IL', x: 65, y: 31 },
  { name: 'New York, NY', x: 89, y: 27 },
  { name: 'Dallas, TX', x: 50, y: 68 },
]

export const images = {
  logo: 'https://cdn.magicpatterns.com/uploads/c6cfKMdwzGXV26GDP36bq7/IMG_2872.jpg',
  hero: 'https://cdn.magicpatterns.com/uploads/9U1jiyons5u9FWsD5bFGza/IMG_9984.jpg',
  yard: 'https://cdn.magicpatterns.com/uploads/rja8s9tbLd2VksztFw5d5Z/IMG_3105.jpg',
  dusk: 'https://cdn.magicpatterns.com/uploads/rFQrm1itRXf8TDUJYpMxfP/IMG_2940.jpg',
  dock: 'https://cdn.magicpatterns.com/uploads/k7PTaFYLqQWoSXh3eTeHuU/E4165C8D-D399-4153-8365-A8ECF7AE6FA1.jpg',
  lot: 'https://cdn.magicpatterns.com/uploads/v6b1c8D6RurgqpCVMYHxFq/IMG_2042.jpg',
  driver: 'https://cdn.magicpatterns.com/uploads/iK6RvQMcG18FhwxamMPutR/IMG_3114.png',
  tires: 'https://cdn.magicpatterns.com/uploads/bJmUzj8XFmEf3TV8sSkcEX/IMG_1897.jpg',
  winter: 'https://cdn.magicpatterns.com/uploads/2FQCxS2XS5zaxDFFFBGf8k/IMG_1429.jpg',
  winterSun: 'https://cdn.magicpatterns.com/uploads/dMrPu4kA4SMZKmuPoCrnFk/IMG_1430.jpg',
}

export const contact = {
  phone: '(954) 627-4168',
  phoneHref: 'tel:+19546274168',
  email: 'info@holdfasthauling.com',
  hq: 'Davenport, Florida',
  site: 'www.holdfasthauling.com',
}
